import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import Cognito from '../components/Cognito'
import Offer from '../components/Offer'
import Mapembed from '../components/Mapembed'
import Address from '../components/Address'

export const LocationsPageTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              <h2 className="title is-size-3 has-text-weight-bold is-bold-light">
                {title}
              </h2>
              <Offer title="$199 Seasonal Spider Control Spray" tag="Effective For Up To 3 Months - New Customers - Homes Up To 3000 sq. ft." price=""/>

              <PageContent className="content" content={content} />
              <Mapembed />  
              <Cognito />
            </div>
            
          </div>
        </div>
        
      </div>
      
    </section>
    
  )
}

LocationsPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

const LocationsPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <LocationsPageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
    </Layout>
  )
}

LocationsPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default LocationsPage

export const locationsPageQuery = graphql`
  query LocationsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`